import React from 'react'
import {Link} from 'react-router-dom'
import '../../assets/css/news.css';
import { toSlug } from '../../utils/utils'
export default function ContentUpComingItem({ info, ind , lang}) {
    return (
        <div className={`post-item-custom ${ind === 3 ? "" : "line-post-item"}`}>
            <div className="event-caption" style={{ display: 'flex', alignItems: 'flex-start', padding: '15px 0' }}>
                <div className="left-box" style={{ minWidth: '20px', marginRight: '15px', paddingTop: '8px' }}>
                    <div className="post-categories">
                            <span className="cat-shape-custom" style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: 'var(--primary-color)' }}>
                            </span>
                    </div>
                </div>
                <div className="right-box" style={{ flex: 1 }}>
                    <h3 className="post-title-relate-2-rows title-has-link" style={{ margin: 0 }}>
                        <Link to={`${lang === 'vi'? '/vi': ''}/listnews/detail/${info.id}-${toSlug(info.title)}`} style={{ fontWeight: 700, fontSize: '16px', color: '#161616', lineHeight: '1.5' }}>{info.title}</Link>
                    </h3>
                </div>
            </div>
        </div>
    )
}
